import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Fab from "@material-ui/core/Fab";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import PhotoUploadIcon from "@material-ui/icons/PhotoCamera";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { Mutation, compose } from "react-apollo";
import gql from "graphql-tag";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withNotification } from "../notification/context";

const UPLOAD_PHOTO = gql`
  mutation updateResearcherPhoto($id: ID!, $file: Upload!) {
    updateResearcherPhoto(id: $id, file: $file) {
      id
      name
      credentials
      descriptions
      photo
    }
  }
`;

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit
  },
  margin: {
    margin: theme.spacing.unit * 2
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  fileZone: {
    borderWidth: 2,
    borderColor: "#DCDCDC",
    borderStyle: "dashed",
    borderRadius: 5,
    margin: theme.spacing.unit * 2
  }
});

const CreateUserModal = ({ classes, openNotification, query, row }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Mutation
      mutation={UPLOAD_PHOTO}
      update={(cache, { data: { updateResearcherPhoto } }) => {
        const { allResearchers } = cache.readQuery({ query });
        const itemIndex = allResearchers.findIndex(
          item => item.id === updateResearcherPhoto.id
        );
        cache.writeQuery({
          query,
          data: {
            allResearchers: [
              ...allResearchers.slice(0, itemIndex),
              updateResearcherPhoto,
              ...allResearchers.slice(itemIndex + 1)
            ]
          }
        });
      }}
    >
      {(uploadPhoto, { data, loading, error }) => (
        <Formik
          initialValues={{ file: null }}
          onSubmit={(values, { resetForm }) => {
            uploadPhoto({ variables: { file: values.file, id: row.id } })
              .then(() => {
                openNotification(
                  `Foto de ${row.name} actualizada correctamente.`
                );
                resetForm();
                handleClose();
              })
              .catch(() => {
                openNotification(`Error al actualizar la foto de ${row.name}`);
                //handleClose();
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            setFieldValue,
            handleSubmit
          }) => {
            return (
              <Form>
                <Tooltip
                  title="Actualizar foto de investigador"
                  placement="bottom"
                >
                  <Fab
                    size="small"
                    className={classes.fab}
                    onClick={handleClickOpen}
                  >
                    <PhotoUploadIcon />
                  </Fab>
                </Tooltip>

                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="form-dialog-title"
                >
                  <DialogTitle id="form-dialog-title">
                    Subir foto de investigador {row.name}
                  </DialogTitle>
                  <DialogContent>
                    <Row center="xs">
                      <Col xs>
                        <div className={classes.fileZone}>
                          <input
                            className={classes.input}
                            style={{ display: "none" }}
                            id="raised-button-file"
                            type="file"
                            onChange={({
                              target: {
                                files: [file]
                              }
                            }) => {
                              setFieldValue("file", file);
                            }}
                          />
                          <label htmlFor="raised-button-file">
                            <Button
                              size="large"
                              variant="contained"
                              component="span"
                              className={classes.margin}
                              disabled={loading}
                            >
                              Seleccionar archivo...
                              <CloudUploadIcon className={classes.rightIcon} />
                            </Button>
                          </label>
                          {errors.file && touched.file && <p>{errors.file}</p>}
                          <Typography variant="body1">
                            {values.file
                              ? `Seleccionado: ${values.file.name}`
                              : "Ningun archivo seleccionado ..."}
                          </Typography>
                        </div>
                      </Col>
                    </Row>
                    <Row center="xs">
                      <Col xs>
                        <DialogContentText>
                          {error && <p>Error :( Por favor intenta de nuevo</p>}
                        </DialogContentText>
                      </Col>
                    </Row>
                    <Row center="xs">
                      <Col xs>
                        {loading ? (
                          <div>
                            <LinearProgress />
                            <span>Cargando ...</span>
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      Cancelar
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                      Subir
                    </Button>
                  </DialogActions>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
      )}
    </Mutation>
  );
};

export default compose(
  withStyles(styles),
  withNotification
)(CreateUserModal);



// WEBPACK FOOTER //
// ./src/components/researchers/upload-photo.js